import React from 'react';

import WalletAccountI from '../types.ts';

const renderTitle: WalletAccountI['renderTitle'] = function () {
    return (
        <div className="popup__title _MOBMAX">
            <div className="popup__titleText">Пополнить баланс</div>
            <div className="popup__titleDescription">
                Сформируется счёт на основании вашего текущего способа оплаты.
            </div>
        </div>
    );
};

export default renderTitle;
